export const toDisplayString = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);
